export const URL = "http://150.95.31.137:4700/api/v1";
export const URL1 = "http://150.95.31.137:4800/api/v1";
export const URL2 = "http://150.95.31.137:4500/api/v1";


